(function () {
  var DIAL_CIRCUMFERENCE = 100.5; // 2 * PI * r(16), matches the SVG circle radius

  document.querySelectorAll(".evoa-matcher").forEach(function (root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll(".evoa-chip"));
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-formula-card]"));
    var resetBtn = root.querySelector("[data-evoa-reset]");
    var bundleSlot = root.querySelector("[data-bundle-slot]");
    var bundles = Array.prototype.slice.call(root.querySelectorAll("[data-bundle]"));
    var selected = new Set();

    function symptomsForFormula(formulaId) {
      var card = root.querySelector('[data-formula-card="' + formulaId + '"]');
      if (!card) return [];
      return Array.prototype.slice
        .call(card.querySelectorAll("[data-symptom-ref]"))
        .map(function (li) {
          return li.getAttribute("data-symptom-ref");
        });
    }

    function chipLabelsForFormula(formulaId) {
      return chips
        .filter(function (chip) {
          return chip.getAttribute("data-formula") === formulaId;
        })
        .map(function (chip) {
          return chip.textContent.trim();
        });
    }

    function update() {
      if (selected.size === 0) {
        cards.forEach(function (card) {
          card.removeAttribute("data-state");
          var badge = card.querySelector("[data-match-badge]");
          if (badge) badge.hidden = true;
        });
        if (resetBtn) resetBtn.hidden = true;
        hideAllBundles();
        return;
      }

      if (resetBtn) resetBtn.hidden = false;

      var bestCount = 0;
      cards.forEach(function (card) {
        var formulaId = card.getAttribute("data-formula-card");
        var ownLabels = chipLabelsForFormula(formulaId);
        var matchCount = ownLabels.filter(function (label) {
          return selected.has(label);
        }).length;
        if (matchCount > bestCount) bestCount = matchCount;
        card.setAttribute("data-match-count", matchCount);
      });

      cards.forEach(function (card) {
        var formulaId = card.getAttribute("data-formula-card");
        var total = parseInt(card.getAttribute("data-total-symptoms"), 10) || 1;
        var matchCount = parseInt(card.getAttribute("data-match-count"), 10) || 0;
        var badge = card.querySelector("[data-match-badge]");
        var dialFill = card.querySelector("[data-dial-fill]");
        var matchText = card.querySelector("[data-match-text]");

        if (matchCount === 0) {
          card.setAttribute("data-state", "muted");
          if (badge) badge.hidden = true;
          if (dialFill) dialFill.style.strokeDashoffset = DIAL_CIRCUMFERENCE;
          return;
        }

        card.removeAttribute("data-state");
        if (matchCount === bestCount) {
          card.setAttribute("data-state", "matched");
        }

        if (badge) badge.hidden = false;
        if (matchText) matchText.textContent = matchCount + "/" + total + " match";
        if (dialFill) {
          var ratio = Math.min(matchCount / total, 1);
          dialFill.style.strokeDashoffset = String(DIAL_CIRCUMFERENCE * (1 - ratio));
        }
      });

      updateBundles();
    }

    function hideAllBundles() {
      if (bundleSlot) bundleSlot.hidden = true;
      bundles.forEach(function (b) {
        b.hidden = true;
      });
    }

    function updateBundles() {
      if (!bundleSlot || bundles.length === 0) return;

      // Collect E-codes for cards that have at least one matched symptom
      var matchedCodes = cards
        .filter(function (card) {
          return parseInt(card.getAttribute("data-match-count"), 10) > 0;
        })
        .map(function (card) {
          return (card.getAttribute("data-formula-code") || "").toUpperCase();
        });

      var anyShown = false;
      bundles.forEach(function (bundle) {
        var codes = (bundle.getAttribute("data-bundle-codes") || "").split(",").map(function (c) {
          return c.trim().toUpperCase();
        });
        var bothMatched = codes.length === 2 && codes.every(function (code) {
          return matchedCodes.indexOf(code) !== -1;
        });
        bundle.hidden = !bothMatched;
        if (bothMatched) anyShown = true;
      });

      bundleSlot.hidden = !anyShown;
    }

    chips.forEach(function (chip) {
      chip.setAttribute("aria-pressed", "false");
      chip.addEventListener("click", function () {
        var label = chip.textContent.trim();
        var pressed = chip.getAttribute("aria-pressed") === "true";
        if (pressed) {
          chip.setAttribute("aria-pressed", "false");
          selected.delete(label);
        } else {
          chip.setAttribute("aria-pressed", "true");
          selected.add(label);
        }
        update();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        selected.clear();
        chips.forEach(function (chip) {
          chip.setAttribute("aria-pressed", "false");
        });
        update();
      });
    }
  });
})();